export default __webpack_public_path__ + "static/media/italic.7ea37a12.svg";